export default defineNuxtPlugin((nuxtApp) => {
  const viewerBaseUrl =
    import.meta.env.VITE_FIREBASE_PROJECT_ID === 'monocle-spdj-staging'
      ? 'https://staging.monocle.link/'
      : 'https://monocle.link/'
  // console.log(`viewerBaseUrl: ${viewerBaseUrl}`)
  nuxtApp.vueApp.provide('MonocleViewerBaseUrl', viewerBaseUrl)
  nuxtApp.provide('MonocleViewerBaseUrl', viewerBaseUrl)
})
